<template>
    
    
        <Teleport to="body">
            <Transition name="bounce">
                <div v-if="modelValue" class="main">
                    <PopupBack blur @click="close()"/>
                    
                    <div ref="target" class="pop" :style="{padding, overflowY: noscroll ? 'hidden' : 'scroll', maxHeight: height}">            
                        
                        <div class="column center debug1">  
                            <div class="column center">
                                <PopupIcon v-if="icon" :name="icon" size="36px"/>                                
                                <div v-if="$slots.icon"><slot name="icon"></slot></div>                                
                                <p v-if="$slots.title || title" class="popuptitle">{{ title }}<slot name="title"></slot></p>                                
                                <p v-if="$slots.line || line" class="line">{{ line }}<slot name="line"></slot></p>                                
                                <p v-if="$slots.desc || sub" class="micro" style="width: 60%; margin-top: 4px;">{{ desc }}<slot name="desc"></slot></p>                                
                            </div>
                            <div class="body"><slot></slot></div>
                            <div class="row center wrap" style="width: 100%;">
                                <hr>
                                <slot name="bottom"></slot>
                            </div>
                        </div>

                        <PopupCloseButton @click="close()"/>                         
                    </div>                    
                </div>            
    </Transition>
</Teleport>
    
<!--         
    
    <Popup v-model="db.settings.login">
        <template #icon><svg/></svg></template>
        <template #title>{{$t('title.welcome')}}</template>
        <template #line>{{$t('line.welcome')}}</template>
        <template #desc>{{$t('desc.welcome') }}</template>  
        <Login @done="db.settings.login = false"/>      
    </Popup>        

-->
     
</template>

<script setup>
// только v-model!
import { useScrollLock } from '@vueuse/core'
import { onMounted, onUnmounted, ref, watch } from 'vue'
/* eslint-disable */
// local
import PopupBack from './PopupBack.vue'
import PopupCloseButton from './PopupCloseButton.vue'
import PopupIcon from './PopupIcon.vue'

const props = defineProps({
  modelValue: Boolean,
  noscroll: Boolean,
  lock: {type:Boolean, default: true},
  title: String,
  desc: String,
  line: String,
  icon: String,
  padding: { type: String, default: '10px' },
  height: { type: String, default: '80vh' },
})

const emit = defineEmits(['update:modelValue', 'close'])
const target = ref(null)

const isBodyLocked = useScrollLock(document.body)

watch(
  () => [props.modelValue, props.lock],
  ([modelValue, lock]) => isBodyLocked.value = !!(modelValue && lock),
  { immediate: true }
)
const close = () => {
    if (!props.modelValue) return
    emit('update:modelValue', false)
    emit('close')
}
const onKeydown = (e) => {if (e.key === 'Escape') close()}

onMounted(() => {window.addEventListener('keydown', onKeydown)})


onUnmounted(() => {
    window.removeEventListener('keydown', onKeydown)
    isBodyLocked.value = false
})
</script>

<style scoped>
.closeButton{
    position: absolute; 
    top: 0px;
    right: 5px; 
    cursor: default;
    padding: 5px 10px;
    color: var(--g1);
    border-radius: 100px;
    cursor: pointer;
    font-size: 20px;
    transition: all 0.2s ease;
}

.closeButton:hover{
    color: var(--g4);
}

 .pop {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        background: var(--popupBack);       
        border-radius: var(--popupBorder);
        position: absolute;  
        z-index: 10000000;
        box-shadow: var(--popupShadow);        
        /* overflow-y: scroll;         */
        /* filter: brightness(1.1); */
   }

.main{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    flex-direction: column;
    position: fixed; 
    z-index: 1; 
    width: 100vw; 
    height: 100vh; 
    top: 0;
    left: 0;
    padding: none,    
}


   .icon{
    /* margin: 10px 0 10px;     */
   }

   .topicon{
    /* position: absolute; */
    margin-top: 20px;
    /* top:10px; */
    z-index: 1000;
   }
   .popuptitle{
        font-family: var(--titleFonts);
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 50%;
        text-align: center;
        letter-spacing: 1%;
        color: var(--title);        
        margin: 8px 0;        
   }

   .line { 
    letter-spacing: 5%;     
    font-size: 13px; 
    font-weight: 400;     
    color: var(--g5); 
    line-height: 18px; 
    margin: 4px 0; 
}
   .sub { 
    letter-spacing: 5%;     
    font-size: 9px; 
    font-weight: 500; 
    text-transform: uppercase; 
    color: var(--g4); 
    line-height: 14px; 
    margin: 0 0 6px; 
}

   /* .desc{
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 140%;
        text-align: center;
        color: var(--g3);
        margin-top: 4px;
        letter-spacing: 0.04em;
        width: 60%;
   } */
   .upperTitle{
        font-family: var(--titleFonts);
        font-style: normal;
        font-weight: 400;
        font-size: 11px;
        line-height: 140%;
        text-align: center;
        color: var(--g3);
        /* margin-top: 4px; */
        letter-spacing: 0.02em;
        margin-bottom: 10px;
        text-transform: uppercase;
   }
   
   .headspace{
    display: flex;
       flex-direction: column;
       justify-content: center;
    width:100%; 
    padding: 10px 0;
    user-select: none;
   }
   .nopadding{
    padding:0
   }
   .wrapper{
       position: relative;
       display: flex;
       flex-direction: column;
       /* justify-content: space-between; */
       align-items: flex-start;
       height: 100%;
       width: 100%;
   }


    .body{
        position: relative;
       display: flex;
       flex-direction: column;
       width: 100%;
       padding: 0px 0px;
   }

    .close{
      cursor: default;
      transition: all 0.1s ease;
    }
    
    .close:hover{
      fill-opacity: 0.16;
    }

    .scroll{
        overflow-y: scroll;
    }

</style>